import Alert from '../../../OxAlerts/OxAlerts'

export default {
    alerts: [] as Alert[],
}
